import { ApiCallState } from "../Utils";
import { IndirectCost } from "../IndirectCost/IndirectCost.type";
import { Project } from "../Project/Project.type";
import { User } from "../User/User.type";

export type EstablishPettyCash = {
  id: number;
  no?: number;
  establishment_no?: string;
  date: string;
  description: string;
  indirect_cost_id?: number;
  indirect_cost?: IndirectCost;
  project_id?: number | null;
  project?: Project;
  store_id?: number | null;
  store?: any;
  department_id?: number | null;
  department?: any;
  is_project?: boolean;
  name_user_id: number;
  name_user?: User;
  initial_balance: number;
  current_balance?: number;
  user_id: number;
  establish_petty_cash_views?: any[];
  establish_petty_cash_checkeds?: any[];
  establish_petty_cash_approveds?: any[];
  establish_petty_cash_authorizeds?: any[];
  createdAt?: any;
  updatedAt?: any;
};

export type EstablishPettyCashStateTypes = {
  fetchAll: ApiCallState<EstablishPettyCash[]>;
  fetchOne: ApiCallState<EstablishPettyCash | {}>;
};

export const EstablishPettyCashActionTypes = {
  FETCH_ALL_ESTABLISH_PETTY_CASH: "FETCH_ALL_ESTABLISH_PETTY_CASH",
  FETCH_ALL_ESTABLISH_PETTY_CASH_RESET: "FETCH_ALL_ESTABLISH_PETTY_CASH_RESET",
  FETCH_ALL_ESTABLISH_PETTY_CASH_FAILURE: "FETCH_ALL_ESTABLISH_PETTY_CASH_FAILURE",
  FETCH_ALL_ESTABLISH_PETTY_CASH_SUCCESS: "FETCH_ALL_ESTABLISH_PETTY_CASH_SUCCESS",

  FETCH_ONE_ESTABLISH_PETTY_CASH: "FETCH_ONE_ESTABLISH_PETTY_CASH",
  FETCH_ONE_ESTABLISH_PETTY_CASH_RESET: "FETCH_ONE_ESTABLISH_PETTY_CASH_RESET",
  FETCH_ONE_ESTABLISH_PETTY_CASH_FAILURE: "FETCH_ONE_ESTABLISH_PETTY_CASH_FAILURE",
  FETCH_ONE_ESTABLISH_PETTY_CASH_SUCCESS: "FETCH_ONE_ESTABLISH_PETTY_CASH_SUCCESS",
};
